import { render } from "./B2bFilterButtonCmrEmit.vue?vue&type=template&id=918def8c&scoped=true&lang=pug"
import script from "./B2bFilterButtonCmrEmit.vue?vue&type=script&lang=js"
export * from "./B2bFilterButtonCmrEmit.vue?vue&type=script&lang=js"

import "./B2bFilterButtonCmrEmit.vue?vue&type=style&index=0&id=918def8c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-918def8c"]])

export default __exports__